module.exports = __webpack_public_path__ + "img/lock.3eb1ed50.svg";